import {useTranslations} from 'next-intl';
import SplitFeatureSection from '@/ui/split-feature-section';
import type {SplitFeatureSectionPlaceholderVariant} from '@/ui/split-feature-section';

const SECTION_KEYS = ['section1', 'section2', 'section3', 'section4'] as const;

type SectionKey = (typeof SECTION_KEYS)[number];

const IMAGE_SIDES: Record<SectionKey, 'left' | 'right'> = {
  section1: 'left',
  section2: 'right',
  section3: 'left',
  section4: 'right'
};

const PLACEHOLDER_VARIANTS: Record<SectionKey, SplitFeatureSectionPlaceholderVariant> = {
  section1: 'lavender',
  section2: 'sand',
  section3: 'mint',
  section4: 'sand'
};

const imgPath = '/static/images/industry-technology/';

const SplitFeaturesSection = () => {
  const t = useTranslations('industryTechnology.splitFeatures');

  return (
    <>
      {SECTION_KEYS.map(sectionKey => {
        const highlights = t.raw(`${sectionKey}.highlights`) as string[];
        const desktopImageUrl = t(`${sectionKey}.desktopImageUrl`);
        const mobileImageUrl = t(`${sectionKey}.mobileImageUrl`);
        const hasImages = Boolean(desktopImageUrl && mobileImageUrl);

        return (
          <SplitFeatureSection
            key={sectionKey}
            id={`split-feature-${sectionKey}`}
            layout="equal"
            imageSide={IMAGE_SIDES[sectionKey]}
            placeholderVariant={PLACEHOLDER_VARIANTS[sectionKey]}
            imgPath={hasImages ? imgPath : undefined}
            responsiveImages={
              hasImages
                ? {
                    desktopImageUrl,
                    mobileImageUrl
                  }
                : undefined
            }
            imageAlt={t(`${sectionKey}.imageAlt`)}
            eyebrow={t(`${sectionKey}.eyebrow`)}
            title={t(`${sectionKey}.title`)}
            description={t(`${sectionKey}.description`)}
            highlightsTitle={t('highlightsTitle')}
            highlights={highlights}
          />
        );
      })}
    </>
  );
};

export default SplitFeaturesSection;
